import { mapGetters } from 'vuex';
import mvtShifter from '@/common/components/mvtshifter/mvt-shifter.vue';
import mvtMapStatic from '@/common/components/mvtmapstatic/mvt-mapstatic.vue';
import mvtCalendar from '@/common/components/mvtcalendar/mvt-calendar.vue';
import mvtTextbox from '@/common/components/mvttextbox/mvt-textbox.vue';
import motime from '../../../common/utilities/motime';
import { getStorage } from '../../../common/utilities/nojq/_localstorage.js';

export default {
    name: 'dppSchedule',
    inject: ['$eventBus'],
    components: {
        mvtShifter,
        mvtMapStatic,
        mvtCalendar,
        mvtTextbox,
    },
    props: {
        assignedAgent: Object,
    },
    data() {
        return {
            data: {
                hotleadType: undefined,
                date: undefined,
                comment: undefined,
            },
        };
    },
    methods: {
        ...mapGetters('glb', ['getComplianceMethod']),
        showNotSupportedByMLS() {
            const compliance = this.getComplianceMethod()();
            return compliance[0] && compliance[0].rule.indexOf('showNotSuportByMLS') >= 0;
        },
        getHotleadPropertyInfo() {
            let list = getStorage('hotleadSentPropertyList');
            if (list) {
                for (const data of list) {
                    if (data.propertyId == this.dpp.propertyId) {
                        return data;
                    }
                }
            }
            return null;
        },
        makeSchedule({ date, hotleadType, hotleadTitle, hotleadSub, changeDate, optionalDate, buttonText, hideProfile, showAddressAndImage, showTourTimePicker }, trigger) {
            this.$eventBus.$emit('dialog-center', {
                name: 'mvtHotleadForm',
                trigger: trigger || this.$options.name,
                opt: {
                    buttonText: buttonText,
                    hotleadType: hotleadType,
                    hotleadTitle: hotleadTitle,
                    hideProfile: hideProfile,
                    hotleadSub: hotleadSub,
                    propertyId: this.dpp.propertyId,
                    propertyData: this.dpp,
                    date: date,
                    timeDisplay: '',
                    overwriteLeadTypeToBuy: true,
                    enableChangeDate: changeDate,
                    optionalDate: optionalDate,
                    showTourTimePicker: !!showTourTimePicker,
                    showComment: false,
                    showAddressAndImage: showAddressAndImage,
                    ojoFormConfigs: {
                        showCtaLinks: false,
                        showOJOagentInfo: true,
                        showDisclaimer: false,
                        commnetLabel: 'Message',
                    },
                },
            });
        },
        openHotlead(buttonText) {
            var cta = buttonText;
            this.$eventBus.$emit('dialog-center', {
                name: 'mvtHotleadForm',
                trigger: this.$options.name,
                opt: {
                    hotleadType: this.data.hotleadType,
                    propertyId: this.dpp.propertyId,
                    propertyData: this.dpp,
                    date: this.data.date,
                    timeDisplay: this.data.timeDisplay,
                    overwriteLeadTypeToBuy: true,
                    enableChangeDate: false,
                    buttonText: cta || 'Request This Time',
                    showComment: false,
                    ojoFormConfigs: {
                        showCtaLinks: false,
                        showOJOagentInfo: true,
                        showDisclaimer: false,
                        commnetLabel: 'Message',
                    },
                },
            });
        },
    },
    created() {
        this.staticMapData = {
            height: 360,
            markers: [],
        };
    },
    computed: {
        ...mapGetters('glb', ['glb', 'getSplit', 'removeAds']),
        ...mapGetters('dpp', ['dpp']),
        selectedAgentId() {
            return this.glb.agent.id;
        },
        getScheduleDate() {
            return this.data.date ? ` on ${motime.formatDate(this.data.date, { month: 'short', day: 'numeric', raw: true })}` : '';
        },
    },
    watch: {
        data: {
            handler: function (val) {
                var dispalyDateComment = val.date ? ` on ${motime.formatDate(val.date, { weekday: 'long', month: 'long', day: 'numeric', raw: true })}` : '';
                val.comment = this.glb.agent.id
                    ? `Hi ${this.glb.agent.firstName}, I am interested in scheduling a viewing of ${this.dpp.geo.formatAddress}${dispalyDateComment}. (${val.timeDisplay})`
                    : '';
            },
            deep: true,
        },
        selectedAgentId(newValue) {
            this.data = { ...this.data, comment: '' };
        },
    },
};
